import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";

function ChangeAmountWarningModal({ show, handleClose }) {
  return (
    <Modal
      size="sm"
      className="no-header-modal"
      scrollable={false}
      animation={false}
      centered
      show={show}
      onHide={() => {}}
    >
      <Modal.Body className="px-3 py-5">
        <div className="fs-18px fw-800">
          銀行振込は
          <span className="color-F35364">10,000円以上</span>
          の支援からご利用いただけます。
          <br />
          支援金額が10,000円未満に減額されたため、お支払い方法を
          <span className="color-F35364">「クレジットカードで決済」</span>
          に戻させていただきました。
        </div>
        <div className="mt-2">
          <button
            className="btn-primary btn-size-md w-100"
            onClick={() => handleClose()}
          >
            閉じる
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(ChangeAmountWarningModal);
